export const createSVGPoint =
  (svg_el) =>
  ([x, y]) => {
    const point = svg_el.createSVGPoint();
    point.x = x;
    point.y = y;
    return point;
  };
